import React from 'react';
import utils from "../../modules/Utilities.module.scss";
import styles from "../../modules/Filters.module.scss";
import grid from "../../modules/Grid.module.scss";
import filterContainerStyle from "../../modules/FilterContainer.module.scss";

export default () => {
    return (
        <div className={grid.flexGrid}>
            {
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(key => {
                    return <div
                        className={`${styles.option} ${utils.desktopOnly} ${grid.col6} ${grid.colSm6} ${grid.colMd4} ${grid.colLg2} ${grid.colXl2}`}
                        key={key}>
                        <div>
                            <div className={filterContainerStyle.dropdown}
                                 style={{
                                     height: 34,
                                     background: 'rgba(0,0,0,0.05)'
                                 }}
                            >
                            </div>
                        </div>
                    </div>;
                })
            }
        </div>
    )
}
